import {lazy, Suspense} from "react";
import { PageSkeleton } from "../../customs/skeleton/main";


const Main = lazy(() => import("../../components/members/messages/main"));

const Messages = () => {

    return(

        <Suspense fallback={<PageSkeleton />}>
            <Main/>
        </Suspense>
      
    )
};

export default Messages;